module.exports = __webpack_public_path__ + "img/pasture_natural_low.90bf0b7b.jpg";